import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";

export const RecalculateScoreEffectActions = {
  recalculateServicePackageScore: `${Entities.RecalculateScore}_recalculateServicePackageScore`,
  recalculateGovResScore: `${Entities.RecalculateScore}_recalculateGovResScore`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.RecalculateScore,
  initSchema,
  aliasName: DIContainerKeys.RecalculateScoreService,
})
export class RecalculateScoreService extends HttpService {
  @loader(Loaders.RecalculateServicePackageScoreModalFlagger)
  @flagger(Flaggers.RecalculateServicePackageScoreModalFlagger)
  @action(DIContainerKeys.RecalculateScoreService)
  public *recalculateServicePackageScore(): Generator<any, void, any> {
    const flaggerState = yield this.di.reduxStore.state()?.[Flaggers.RecalculateServicePackageScoreModalFlagger] || {};
    yield this.setFlaggerState(Flaggers.RecalculateServicePackageScoreModalFlagger, { ...flaggerState, isLoading: true });
    yield this.setLoaderState(Loaders.RecalculateServicePackageScoreModalFlagger, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.RecalculateServicePackageScore),
      },
      ReducerMethods.UPDATE
    );
    yield this.setFlaggerState(Flaggers.RecalculateServicePackageScoreModalFlagger, { ...flaggerState, isLoading: false });
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.RecalculateServicePackageScoreModalFlagger, false);
      return;
    }
    yield this.setFlaggerState(Flaggers.RecalculateServicePackageScoreModalFlagger, null);
    yield this.setLoaderState(Loaders.RecalculateServicePackageScoreModalFlagger, false);
  }

  @loader(Loaders.RecalculateGovResScoreModalFlagger)
  @flagger(Flaggers.RecalculateGovResScoreModalFlagger)
  @action(DIContainerKeys.RecalculateScoreService)
  public *recalculateGovResScore(): Generator<any, void, any> {
    const flaggerState = yield this.di.reduxStore.state()?.[Flaggers.RecalculateGovResScoreModalFlagger] || {};
    yield this.setFlaggerState(Flaggers.RecalculateGovResScoreModalFlagger, { ...flaggerState, isLoading: true });
    yield this.setLoaderState(Loaders.RecalculateGovResScoreModalFlagger, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.RecalculateGovResScore),
      },
      ReducerMethods.UPDATE
    );
    yield this.setFlaggerState(Flaggers.RecalculateGovResScoreModalFlagger, { ...flaggerState, isLoading: false });
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.RecalculateGovResScoreModalFlagger, false);
      return;
    }
    yield this.setFlaggerState(Flaggers.RecalculateGovResScoreModalFlagger, null);
    yield this.setLoaderState(Loaders.RecalculateGovResScoreModalFlagger, false);
  }
}
